export const authUrl = 'auth';
